module.exports = __webpack_public_path__ + "static/media/subscription_banner.cc67a52b.jpg";